import { AsText } from '../text-and-lang/as-text.js';
import styleText from './as-param-group.css?raw';

export class AsParamGroup extends HTMLElement {
  static get observedAttributes() {
    return ['subheading-default-text', 'subheading-dict-key'];
  }

  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsParamGroup.sheet
    ];
    
    this.shadowRoot!.innerHTML = /*html*/`
      <div class="header">
        <h3 class="subheading"></h3>
      </div>
      <div class="content">
        <slot></slot>
      </div>
    `;
  }

  connectedCallback() {
    this.updateSubheading();
  }

  attributeChangedCallback(name: string, _oldValue: string, _newValue: string) {
    if (['subheading-default-text', 'subheading-dict-key'].includes(name)) {
      this.updateSubheading();
    }
  }

  private updateSubheading() {
    const subheadingElement = this.shadowRoot?.querySelector('.subheading');
    if (!subheadingElement) return;

    const dictKey = this.getAttribute('subheading-dict-key');
    const defaultText = this.getAttribute('subheading-default-text');

    subheadingElement.innerHTML = '';

    if (dictKey || defaultText) {
      const asText = document.createElement('as-text') as AsText;
      
      if (dictKey) {
        asText.setAttribute('dict-key', dictKey);
      }
      if (defaultText) {
        asText.textContent = defaultText;
      }

      subheadingElement.appendChild(asText);
    }
  }
}

if (!customElements.get('as-param-group')) {
  customElements.define('as-param-group', AsParamGroup);
} else {
  console.warn('as-param-group already defined');
}
